// @flow
import React, { Component, Fragment } from "react";
import moment from "moment";

import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import type { ChartType } from "../../../global//types/BillingChartType";
import BillingTable from "../../components/billings/BillingTable";

type CurrentBillingPropsType = {
  estimate: { [key: string]: * }
};

type CurrentBillingStatesType = {
  charts: Array<ChartType>
};

class CurrentBilling extends Component<CurrentBillingPropsType, *> {
  constructor(props: CurrentBillingPropsType) {
    super(props);
    this.state = {
      charts: null
    };
  }

  componentDidMount() {
    const total = this.props.estimate.total;
    const items = this.props.estimate.items;
    let charts = [];
    items.forEach(
      (item: *, i: number): * => {
        charts.push({
          id: item.partNo,
          name: item.name,
          count: item.count,
          price: item.price,
          total: item.summary
        });
      }
    );

    this.setState({ charts: charts });
  }

  render(): React$Element<*> {
    const total = parseFloat(this.props.estimate.total).toFixed(2);

    return (
      <Paper className="box-wrapper">
        <Typography variant="h5" className="form-text">
          Bill Estimate
        </Typography>
        <Typography variant="subtitle1" className="form-hint form-text">
          Current month-to-date estimate for {moment.utc().format("MMMM YYYY")}
        </Typography>
        <Typography variant="h3" className="form-text">
          ${total} AUD
        </Typography>
        <Typography variant="subtitle1" className="form-hint form-text">
          as of today
        </Typography>
        <BillingTable charts={this.state.charts} total={total} />
      </Paper>
    );
  }
}

export default CurrentBilling;
